import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsWorkflowsRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-workflows',
	path: '/plugins/servlet/project-config/:projectKey/workflows',
};
